import React from 'react'
import styled from 'styled-components'

import { Icon } from 'components/base-ui'

interface IconDetailProps extends React.HTMLAttributes<HTMLDivElement> {
  name: string
  size?: string
}

const IconDetail: React.FC<IconDetailProps> = ({ name, size, ...props }) => {
  return (
    <IconWrapper {...props}>
      <Icon name={name} size={size} />
    </IconWrapper>
  )
}

export default IconDetail

const IconWrapper = styled.div`
  min-width: 30px;
  padding-top: 2px;

  i {
    font-size: 20px;
    color: ${(props) => props.theme.colors.primary};
  }
`
